const UTXO_EXPLORER_URL =
  import.meta.env.VITE_UTXO_EXPLORER_URL ||
  'https://explorer-blockbook.syscoin.org';

interface UtxoBlockHeaderProps {
  height: number;
  hash: string;
  confirmations?: number;
}

export const UtxoBlockHeader = ({ height, hash, confirmations }: UtxoBlockHeaderProps) => (
  <div
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      alignItems: 'center',
      marginBottom: '10px',
    }}
  >
    <div style={{ flex: '1 1 auto', minWidth: '200px' }}>
      <h1 style={{ margin: 0, display: 'inline' }}>
        UTXO Block #{height}
      </h1>
      {confirmations != null && (
        <span style={{ fontSize: '0.9em', color: '#8b92a8', marginLeft: '10px' }}>
          ▪ {confirmations.toLocaleString()} confirmation{confirmations === 1 ? '' : 's'}
        </span>
      )}
    </div>
    <div style={{ display: 'flex', gap: '10px' }}>
      <a
        href={`${UTXO_EXPLORER_URL}/block/${hash}`}
        className="nav-button"
        target="_blank"
        rel="noopener"
      >
        View on Blockbook ↗
      </a>
      <a
        href={`https://chainz.cryptoid.info/sys/block.dws?${hash}.htm`}
        className="nav-button"
        target="_blank"
        rel="noopener"
      >
        View on CryptoID ↗
      </a>
    </div>
  </div>
);
